var Alignment;
(function (Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["CENTER"] = "center";
    Alignment["RIGHT"] = "right";
})(Alignment || (Alignment = {}));
var HeadlineType;
(function (HeadlineType) {
    HeadlineType["PAGE"] = "page";
    HeadlineType["BIG"] = "big";
    HeadlineType["SMALL"] = "small";
})(HeadlineType || (HeadlineType = {}));

export { Alignment, HeadlineType };
